<div class="zn-step-content-sections">
    <div [class]="filterSectionClass()">
        <div class="zn-step-content-section-header">
            <h5>{{ (localizationKeyPrefix + '.Filters.Title') | abpLocalization }}</h5>
            <p>{{ (localizationKeyPrefix + '.Filters.Description') | abpLocalization }}</p>
            <hr class="zn-separator">
        </div>
        <div class="zn-step-content-section-body">
            <div class="zn-step-content-section-layout">
                <div class="zn-step-content-section-filters">
                    <div class="form-control-container">
                        <label class="form-label" for="">
                            {{ 'Planning::Entity.Property' | abpLocalization }}
                        </label>
                        <zn-multi-select
                            #propertySelect
                            [options]="propertyOptions()"
                            [optionsLoader]="propertyOptionsLoader"
                            [emptyDisplayValue]="'LanguageService::ZnAll'"
                            [emptySelectionIsAll]="true"
                            (selectedChange)="onPropertyChange($event)">
                        </zn-multi-select>
                    </div>
                    <div class="form-control-container">
                        <label class="form-label" for="">
                            {{ 'WoodSupply::Entity.HarvestBlock' | abpLocalization }}
                        </label>
                        <zn-multi-select
                            #harvestBlockSelect
                            [options]="harvestBlockOptions()"
                            [optionsLoader]="harvestBlockOptionsLoader"
                            [emptyDisplayValue]="'LanguageService::ZnAll'"
                            [emptySelectionIsAll]="true"
                            (selectedChange)="onHarvestBlockChange($event)">
                        </zn-multi-select>
                    </div>
                </div>
                <div class="zn-step-content-section-actions">
                    <zn-button type="primary" size="normal" [label]=" 'LanguageService::ApplyFilters' | abpLocalization"  (clicked)="applyFilters()" [loading]="loading()" [disabled]="!canApplyFilters() || loading()" loadingIconPosition="left" ></zn-button>
                    <zn-button type="tertiary" size="normal" iconLeft="bi bi-eraser" [label]=" 'LanguageService::InputResumeReset' | abpLocalization" (clicked)="cleanFilters()" [disabled]="!canClearFilters() || loading()"></zn-button>
                </div>
            </div>
        </div>
    </div>
    <div [class]="tableSectionClass()">
        <div class="zn-step-content-section-header">
            <h5>{{ (localizationKeyPrefix + '.StandsTable.Title') | abpLocalization }}</h5>
            <p>{{ (localizationKeyPrefix + '.StandsTable.Description') | abpLocalization }}</p>
            <hr class="zn-separator">
        </div>
        <div class="zn-step-content-section-body">
            <div class="zn-table" [class.zn-table--empty]="rows().length === 0" [attr.aria-busy]="loading()">
                <div class="zn-table-scroll">
                    <table class="zn-table-element">
                        <thead>
                            <tr>
                                <th class="zn-table-checkbox-column">
                                    <input
                                        type="checkbox"
                                        [checked]="allRowsSelected()"
                                        [indeterminate]="someRowsSelected()"
                                        [disabled]="!hasRows() || loading()"
                                        [attr.aria-label]="'LanguageService::ZnSelectAll' | abpLocalization"
                                        (change)="onToggleAllRows($any($event.target).checked)"
                                    />
                                </th>
                                <th>{{ columnHeaderKeys.standName | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.cycleNumber | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.rotationNumber | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.propertyName | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.harvestBlockName | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.standArea | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.productivityParameterName | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.dab | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.stumpApplicationName | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.applyFeller | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.measurementTypeName | abpLocalization }}</th>
                                <th>{{ columnHeaderKeys.inventoryTypeName | abpLocalization }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @if (rows().length === 0) {
                                <tr>
                                    <td class="zn-table-empty" colspan="13">
                                        {{ 'LanguageService::EmptySearchResultTitle' | abpLocalization }}
                                    </td>
                                </tr>
                            }
                            @for (row of rows(); track row.id) {
                                <tr>
                                    <td class="zn-table-checkbox-column">
                                        <input
                                            type="checkbox"
                                            [checked]="selectedRowIds().has(row.id!)"
                                            [disabled]="loading()"
                                            [attr.aria-label]="row.standName"
                                            (change)="onToggleRow(row.id, $any($event.target).checked)"
                                        />
                                    </td>
                                    <td>{{ row.standName }}</td>
                                    <td>{{ row.cycleNumber }}</td>
                                    <td>{{ row.rotationNumber }}</td>
                                    <td>{{ row.propertyName }}</td>
                                    <td>{{ row.harvestBlockName }}</td>
                                    <td>{{ row.standArea }}</td>
                                    <td>{{ row.productivityParameterName }}</td>
                                    <td>{{ row.dab }}</td>
                                    <td>{{ row.stumpApplicationName }}</td>
                                    <td>{{ row.applyFeller }}</td>
                                    <td>{{ row.measurementTypeName }}</td>
                                    <td>{{ row.inventoryTypeName }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
